import React from 'react';
import styled from 'styled-components';
import { createPortal } from 'react-dom';
import { withQuery } from '@panel/commons/core/themev2';

const Back = styled.div`
  z-index: 499;
  background-color: ${({ backgroundColor }) => backgroundColor || 'rgba(0, 0, 0, 0.5)'};
  width: 100%;
  height: 100%;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
`;

const SubWrapper = styled.div`
  display: flex;
  z-index: 500;
  position: fixed;
  min-width: 100px;
  min-height: 100px;
  justify-content: center;
  align-items: center;
  ${withQuery.md.down()} {
    height: 100vh;
    padding-bottom: 30px;
  }
  ${withQuery.xs.down()} {
    align-items: flex-start;
    padding-bottom: 50px;
  }
`;

const ModalWrapper = ({ children, innerRef, backgroundColor }) => {
  return (
    <Back backgroundColor={backgroundColor}>
      <SubWrapper ref={innerRef}>{children}</SubWrapper>
    </Back>
  );
};

const Modal = React.forwardRef(({ children, backgroundColor }, ref) =>
  createPortal(
    <ModalWrapper innerRef={ref} backgroundColor={backgroundColor}>
      {children}
    </ModalWrapper>,
    document.getElementById('modal-root')
  )
);

export { Modal };
